import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FinraFormsService } from '@finra/forms';
import { AbstractSchemaService, AbstractSchemaServiceEnv } from '@finra/rampdi-forms-common';
import { environment } from '../../environments/environment';
import { NavigationDataService } from './navigation-data.service';

export const schemaObj = {
  identifyingInformation: {
    schema: '#/',
    id: 'identifyingInformation',
    title: 'Identifying Information',
  },
  residentRegisteredAgent: {
    schema: '#/',
    id: 'residentRegisteredAgent',
    title: 'Resident/Registered Agent',
  },
  webAddresses: {
    schema: '#/',
    id: 'webAddresses',
    title: 'Web Addresses',
  },
  approvalsAndDesignations: {
    schema: '#/',
    id: 'approvalsAndDesignations',
    title: 'Approvals and Designations',
  },
  legalStatusDataCollection: {
    schema: '#/',
    id: 'legalStatusDataCollection',
    title: 'Legal Status - Data Collection',
  },
  affiliatesSubsidiaries: {
    schema: '#/',
    id: 'affiliatesSubsidiaries',
    title: 'Affiliates/Subsidiaries',
  },
  financialInstitutions: {
    schema: '#/',
    id: 'financialInstitutions',
    title: 'Financial Institutions',
  },
};

@Injectable({
  providedIn: 'root',
})
export class SchemaService extends AbstractSchemaService {
  constructor(
    navDataService: NavigationDataService,
    http: HttpClient,
    router: Router,
    route: ActivatedRoute,
    ffs: FinraFormsService,
  ) {
    super(schemaObj, navDataService, http, router, route, ffs);
  }

  resolve(route: any, state: any) {
    this.schemaObj = schemaObj;
    return super.resolve(route, state);
  }

  get environment(): AbstractSchemaServiceEnv {
    return environment;
  }
}
